<template>
  <div class="companies">
    <LoadingSpinner v-if="loading" />
    <template v-else>
      <SectionHeader>
        <template v-slot:breadcrumbs>
          <BreadCrumbs :items="[{ text: $t('projects.projects'), name: 'company_projects' }, { text: project.name }]" />
        </template>
        <template slot="meta">
          <button
            v-if="companyUser.user_admin"
            :disabled="!project.can_be_deleted"
            @click="removeProject"
            class="button button-red button-small button-round"
            style="margin-right: 10px"
          >
            {{ $t('projects.delete') }}
          </button>
          <Link :to="`/company/projects`" class="button button-green button-small button-round">{{
            $t('projects.allProjects')
          }}</Link>
        </template>
      </SectionHeader>

      <div class="body-content cf">
        <CompanyNav />
        <div class="body">
          <div class="content-wrap">
            <header class="content-header cf">
              <h3>{{ $t('meta.baseData') }}</h3>
            </header>
            <div class="content-body">
              <ProjectForm @submit="updateProject" :companyUuid="companyUser.company_uuid" :initialProject="project" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ProjectForm from '@/views/companies/projects/form'

import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import projectsApi from '@/api/projects'

export default {
  name: 'company_project',
  inject: ['companyUser', 'showPopup'],
  data: () => ({
    project: null,
    loading: true,
  }),
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    ProjectForm,
    SectionHeader,
  },
  methods: {
    async removeProject() {
      const popupResult = await this.showPopup({
        content: this.$t('projects.deleteConfirmation'),
        confirmText: this.$t('projects.deleteConfirmText'),
        type: 'confirmDanger',
      })
      if (!popupResult) return

      const result = await projectsApi.delete(this.project?.uuid)
      if (!result.success) return

      this.$router.push(`/company/projects`)
    },
    updateProject: async function (project) {
      await projectsApi.update(this.$route.params.project_uuid, project)
    },
  },
  async mounted() {
    this.project = await projectsApi.get(this.$route.params.project_uuid)
    this.loading = false
  },
}
</script>
